import React from "react";

import type { MorePostsProps } from "@/mk2/apps/forum/components/MorePosts";
import Loadable from "@/mk2/helpers/Loadable";

/**
 * SSR-safe lazy-loaded MorePosts.
 *
 * MorePosts (related/linked forum posts) renders only when a wiki/review article
 * actually has discussions or similar posts. Importing it statically pulled forum
 * UI code into every wiki article chunk even on pages with no forum content.
 * Loading it via react-loadable moves it into a separate async chunk fetched only
 * when it renders; it stays server-side rendered (server does Loadable.preloadAll)
 * and its chunk is preloaded before hydration when rendered, so there is no
 * hydration mismatch and no visible change.
 *
 * NOTE: this does NOT remove forum/schemas from the review bundle — ArticlePage
 * still imports PostSchema at runtime to denormalize forum posts from the store.
 */
export const MorePosts = Loadable<
    MorePostsProps,
    typeof import("@/mk2/apps/forum/components/MorePosts")
>({
    loader: () =>
        import(
            "@/mk2/apps/forum/components/MorePosts" /* webpackChunkName: "apps.forum.components.MorePosts" */
        ),
    modules: ["@/mk2/apps/forum/components/MorePosts"],
    webpack: () => [require.resolveWeak("@/mk2/apps/forum/components/MorePosts")],
    render(loaded, props) {
        const Component = loaded.MorePosts;
        return <Component {...props} />;
    },
});
